import { VulnerabilityData, FilterType } from '~/types/active3rdPartyVuln'

export const SEVERITY_MAPPINGS = {
  cri: 'Critical',
  hig: 'High',
  med: 'Medium',
  low: 'Low'
} as const

export const REACHABILITY_MAPPINGS = {
  rea: { name: 'Reachable', icon: 'map-pin-check-inside' },
  unr: { name: 'Unreachable', icon: 'map-pin-cross-inside' },
  unk: { name: 'Unknown', icon: 'map-pin-dash-inside' }
} as const

export function mapVulnerabilityNames(
  data: VulnerabilityData[],
  filterType: FilterType
): VulnerabilityData[] {
  if (!Array.isArray(data)) return []

  if (filterType === FilterType.SEVERITY) {
    return data.map((item) => ({
      ...item,
      name: SEVERITY_MAPPINGS[item.slug as keyof typeof SEVERITY_MAPPINGS] || item.name || item.slug
    }))
  } else {
    return data.map((item) => ({
      ...item,
      name:
        REACHABILITY_MAPPINGS[item.slug as keyof typeof REACHABILITY_MAPPINGS]?.name ||
        item.name ||
        item.slug
    }))
  }
}

export function transformHistoricalData(
  data: Record<string, number[]>,
  filterType: FilterType
): VulnerabilityData[] {
  if (!data || typeof data !== 'object') return []

  if (filterType === FilterType.SEVERITY) {
    return Object.entries(data).map(([slug, values]) => ({
      slug,
      name: SEVERITY_MAPPINGS[slug as keyof typeof SEVERITY_MAPPINGS] || slug,
      value: Array.isArray(values) && values.length > 0 ? values[values.length - 1] : 0
    }))
  } else {
    return Object.entries(data).map(([slug, values]) => ({
      slug,
      name: REACHABILITY_MAPPINGS[slug as keyof typeof REACHABILITY_MAPPINGS]?.name || slug,
      value: Array.isArray(values) && values.length > 0 ? values[values.length - 1] : 0
    }))
  }
}

export function getFilterLabel(key: string, filterType: FilterType): string {
  if (filterType === FilterType.SEVERITY) {
    return SEVERITY_MAPPINGS[key as keyof typeof SEVERITY_MAPPINGS] || key
  } else {
    return REACHABILITY_MAPPINGS[key as keyof typeof REACHABILITY_MAPPINGS]?.name || key
  }
}
